export default __webpack_public_path__ + "static/media/edit-svgrepo-com.0cfe1d35.svg";